import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { repeat } from 'rxjs/operators';

const DEBUG = true;

/** Constants used in the script tag */
const GAPI_URL = 'https://apis.google.com/js/api.js';
const SCRIPT_MIME_TYPE = 'text/javascript';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  onLoaded$: Observable<Event>;

  constructor() {
    if (DEBUG) {console.log('new ScriptLoaderService()');}
    const script = document.createElement('script');
    script.async = true;
    script.src = GAPI_URL;
    script.type = SCRIPT_MIME_TYPE;
    script.onload = () => {
      if (DEBUG) { console.log('ScriptLoaderService script loading now'); }
    };
    document.getElementsByTagName('head')[0].appendChild(script);
    this.onLoaded$ = fromEvent(script, 'load').pipe(repeat(1));
  }

}
